import React from 'react';
import {
  BottomSheetBackdrop as BaseBackdropComponent,
  BottomSheetBackdropProps,
} from '@gorhom/bottom-sheet';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

export const BottomSheetBackdrop: React.FC<BottomSheetBackdropProps> = (
  props,
) => {
  return (
    <BaseBackdropComponent
      {...props}
      appearsOnIndex={0}
      disappearsOnIndex={-1}
      enableTouchThrough={false}
      opacity={0.5}
      pressBehavior="close"
    />
  );
};

export const AffordanceHandleIndicator: React.FC = () => {
  const [styles] = useStyles();
  return <View style={styles.handleIndicator} />;
};

export const AffordanceHandleIndicatorWithSpacing: React.FC = () => {
  const [styles] = useStyles();
  return (
    <View style={[styles.handleIndicator, styles.spacedHandleIndicator]} />
  );
};

const useStyles = createStyles((theme) => ({
  handleIndicator: {
    alignSelf: 'center',
    backgroundColor: theme.sk.color.bg.scrollbar,
    borderRadius: 100,
    height: 4,
    marginTop: 8,
    width: 32,
  },
  spacedHandleIndicator: {
    marginBottom: 16,
  },
}));
